import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '@/App';

/**
 * Hook que retorna a % de comissão vigente da plataforma
 * (SOURCE OF TRUTH oficial: `system_config.platform_fee_percent`).
 *
 * Use-o sempre que precisar derivar "Você recebe" / valor líquido no FRONTEND
 * para appointments legados que NÃO trazem `provider_amount` materializado.
 * Para appointments novos, prefira sempre o `provider_amount` já calculado
 * no backend (que também usa este source of truth).
 *
 * Retorno:
 *   {
 *     platformFeePercent: number,       // ex.: 25
 *     platformFeeRatio:   number,       // ex.: 0.25
 *     providerNetRatio:   number,       // ex.: 0.75
 *     loading:            boolean,
 *   }
 */
export default function usePlatformFee() {
  const [data, setData] = useState({
    platformFeePercent: 25,
    platformFeeRatio: 0.25,
    providerNetRatio: 0.75,
    loading: true,
  });

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API}/admin/config/platform-fee`, {
          headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        });
        if (!active) return;
        const pct = Number(res.data?.platform_fee_percent ?? 25);
        setData({
          platformFeePercent: pct,
          platformFeeRatio: pct / 100,
          providerNetRatio: 1 - pct / 100,
          loading: false,
        });
      } catch (e) {
        if (!active) return;
        // mantém defaults 25% (e remove loading)
        setData((prev) => ({ ...prev, loading: false }));
      }
    };
    load();
    return () => { active = false; };
  }, []);

  return data;
}
